import "react-app-polyfill/ie11";
import "react-app-polyfill/stable";
import "core-js/stable";
import "regenerator-runtime/runtime";
import React from "react";
import ReactDOM from "react-dom";
import "./index.scss";
import App from "./App";
import * as serviceWorker from "./serviceWorker";
import { Provider } from "react-redux";
import { configureStore } from "@reduxjs/toolkit";
import rootReducer from "./redux/reducers";
import { BrowserRouter } from "react-router-dom";
import { PublicClientApplication } from "@azure/msal-browser";
import { MsalProvider } from "@azure/msal-react";
import { loadConfig, getMsalConfig } from "./utils/auth-config";

const store = configureStore({ reducer: rootReducer });

async function bootstrap() {
    await loadConfig();

    const msalInstance = new PublicClientApplication(getMsalConfig());

    await msalInstance.handleRedirectPromise();

    ReactDOM.render(
        <Provider store={store}>
            <BrowserRouter>
                <MsalProvider instance={msalInstance}>
                    <App />
                </MsalProvider>
            </BrowserRouter>
        </Provider>,
        document.getElementById("root")
    );
}

bootstrap();


// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
